import { Injectable } from '@angular/core';
import { BaseStoreService } from '@src/app/modules/base';

import { GroupItem } from '../../types';

@Injectable({
  providedIn: 'root',
})
export class LpCategoriesStoreService extends BaseStoreService<ReadonlyArray<GroupItem>> {}
